<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

export default {
    name: 'App',
    data() {
        return {

        }
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style>
  html ::-webkit-scrollbar {
    width: 5px;
    height: 4px;
  }

  html ::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background: rgb(202, 201, 201);
  }
</style>
